import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { OptionInterface } from '@app/interfaces/option.interface';

@Injectable({ providedIn: 'root' })
export class OptionService extends ApiService<OptionInterface> {
    // @API options
    protected serviceName = 'options';

    private readonly loadTypes: string[] = [
        'propertyType',
        'purpose',
        'education',
        'currency',
        'timeHorizon',
        'familyStatus',
        'employeeStatus',
        'fixation',
        'incomeType',
        'incomeSector',
        'nace',
        'costAccounting',
        'flatRate',
        'expenditureType',
        'incomeLocation',
        'memberType',
        'householdType',
        'creditorType',
        'help',
        'bank',
        'job',
        'refinancedBank',
        'sex',
        'country',
        'residence',
        'rentalIncomeType',
        'profession',
    ];

    constructor() {
        super();
        this.initConnection();
        this.loadByType();
    }

    public getListByType(type: string): any[] {
        const list = this.items.find((x) => x.type === type);
        return list?.options ?? [];
    }

    public loadByType(type?: string) {
        const typesArray: any[] = type ? type.split(',') : [];
        this.load({
            type: {
                $in: [...this.loadTypes, ...typesArray],
            },
        });
    }

    public load(query?: any) {
        if (!this.isLoading) {
            this.isLoading = true;
            // @API options.find
            this.find({ query })
                .then((data) => {
                    this.items = data;
                })
                .catch(() => {
                    this.items = [];
                })
                .finally(() => {
                    this.itemsSubject.next(this.items);
                    this.itemsLoaded.next(!!this.items?.length);
                    this.isLoading = false;
                });
        }
    }
}
